import Vue from "vue";
import VueRouter from "vue-router";
import index from "../views/index.vue";
import AboutUs from "../views/AboutUs.vue";
import solution from "../views/solution.vue";
import news from "../views/news.vue";
import newsDetails from "../views/newsDetails.vue";
import product from "../views/product.vue";
import productDetails from "../views/productDetails.vue";
import download from "../views/download.vue";
import contactUs from "../views/contactUs.vue";

import GroupNews from "../views/News/GroupNews.vue";
import MediaCoverage from "../views/News/MediaCoverage.vue";
import TradeNews from "../views/News/TradeNews.vue";
import energy from "../views/Solution/energy.vue";
import power from "../views/Solution/power.vue";
import cable from "../views/Solution/cable.vue";
// routes: ['/', '/solution', '/product', '/productDetails', '/news', '/newsDetal', '/download', '/AboutUs', '/contactUs'],


// 报错解决
// 获取原型对象push函数
const originalPush = VueRouter.prototype.push;

// 获取原型对象replace函数
const originalReplace = VueRouter.prototype.replace;

// 修改原型对象中的push函数
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err);
};

// 修改原型对象中的replace函数
VueRouter.prototype.replace = function replace(location) {
	return originalReplace.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "index",
		component: index,
		meta: {
			title: "江西正能智慧科技有限公司官网",
		},
	},
	{
		path: "/AboutUs",
		name: "AboutUs",
		component: AboutUs,
		meta: {
			title: "关于我们-江西正能智慧科技有限公司官网",
		},
	},
	{
		path: "/solution",
		name: "solution",
		component: solution,
		children: [
			{
				path: "",
				component: energy,
				name: "energy",
				meta: {
					title: "能源管理系统-江西正能智慧科技有限公司官网",
				},
			},
			{
				path: "power",
				component: power,
				name: "power",
				meta: {
					title: "变压器监控运维理管平台-江西正能智慧科技有限公司官网",
				},
			},
			{
				path: "cable",
				name: "cable",
				component: cable,
				meta: {
					title: "电缆安全监测系统-江西正能智慧科技有限公司官网",
				},
			},
		],
		meta: {
			title: "解决方案-江西正能智慧科技有限公司官网",
		},
	},
	{
		path: "/news",
		name: "news",
		component: news,
		children: [
			{
				path: "",
				component: GroupNews,
				name: "GroupNews",
				meta: {
					title: "公司动态-江西正能智慧科技有限公司官网",
				},
			},
			{
				path: "MediaCoverage",
				component: MediaCoverage,
				name: "MediaCoverage",
				meta: {
					title: "行业资讯-江西正能智慧科技有限公司官网",
				},
			},
			{
				path: "TradeNews",
				name: "TradeNews",
				component: TradeNews,
				meta: {
					title: "技术问题-江西正能智慧科技有限公司官网",
				},
			},
		],
		meta: {
			title: "新闻资讯-江西正能智慧科技有限公司官网",
		},
	},
	{
		path: "/newsDetails",
		name: "newsDetails",
		component: newsDetails,
		meta: {
			title: "新闻详情-江西正能智慧科技有限公司官网",
		},
	},
	{
		path: "/product",
		name: "product",
		component: product,
		meta: {
			title: "产品中心-江西正能智慧科技有限公司官网",
		},
	},
	{
		path: "/productDetails/:id",
		name: "productDetails",
		component: productDetails,
		meta: {
			title: "设备详情-江西正能智慧科技有限公司官网",
		},
	},
	{
		path: "/contactUs",
		name: "contactUs",
		component: contactUs,
		meta: {
			title: "联系我们-江西正能智慧科技有限公司",
		},
	},
	{
		path: "/download",
		name: "download",
		component: download,
		meta: {
			title: "应用下载-江西正能智慧科技有限公司官网",
		},
	},
	
];
// title

const router = new VueRouter({
	mode: 'history',
	routes,
	// 跳转页面后 回到顶部
	scrollBehavior() {
		return {
			x: 0,
			y: 0,
		};
	},
});

export default router;

//title
const defaultTitle = "默认 title";
router.beforeEach((to, from, next) => {
	document.title = to.meta.title ? to.meta.title : defaultTitle;
	next();
});
